import integrityTest from './sql-trainer-tests/integrityTest';
import beginnerTest from './sql-trainer-tests/beginnerTest';
import analyticsTest from './sql-trainer-tests/analyticsTest';
import infraTest from './sql-trainer-tests/infraTest';
import experimentTest from './sql-trainer-tests/experimentTest';

/**
 * Registry of all available SQL test sets
 * Each test contains schema, seed data, and questions
 */
export const SQL_TESTS = {
  beginner: beginnerTest,
  integrity: integrityTest,
  analytics: analyticsTest,
  infra: infraTest,
  experiment: experimentTest
};

/**
 * Default test to load on first visit
 */
export const DEFAULT_TEST = 'beginner';

/**
 * Get test by ID
 */
export const getTest = (testId) => {
  return SQL_TESTS[testId] || SQL_TESTS[DEFAULT_TEST];
};

/**
 * Get all test IDs
 */
export const getTestIds = () => {
  return Object.keys(SQL_TESTS);
};

/**
 * Get test metadata for display in selector
 */
export const getTestMetadata = () => {
  return Object.keys(SQL_TESTS).map(id => ({
    id,
    name: SQL_TESTS[id].name,
    subtitle: SQL_TESTS[id].subtitle,
    questionCount: SQL_TESTS[id].questions.length
  }));
};
